import * as actionTypes from "../actions/actionTypes";
import {
    addRecordFail,
    addRecordStart,
    addRecordSuccess,
    clearAddRecordError,
    clearUpdateRecordError,
    updateRecordFail,
    updateRecordStart,
    updateRecordSuccess,
    clearAddRecordLoading,
    clearUpdateRecordLoading,
    cancelAddRecord,
    cancelUpdateRecord,
    fetchRecordStart,
    fetchRecordFail,
    fetchRecordSuccess,
    clearRecord,
    fetchListStart,
    fetchListSuccess,
    fetchListFail,
    clearList,
    clearAllLists,
    addToTopOfLists,
    updateInLists,
    removeFromLists,
    updateSingleRecord
} from "../utility";

const initialState = {
    lists: {},
    record: null,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_MESSAGE_LIST_START: return fetchListStart(state, action.payload);
        case actionTypes.FETCH_MESSAGE_LIST_SUCCESS: return fetchListSuccess(state, action.payload);
        case actionTypes.FETCH_MESSAGE_LIST_FAIL: return fetchListFail(state, action.payload);
        case actionTypes.CLEAR_MESSAGE_LIST: return clearList(state, action.payload);
        case actionTypes.CLEAR_MESSAGE_LISTS: return clearAllLists(state);
        case actionTypes.ADD_TO_MESSAGE_LIST: return addToTopOfLists(state, action.payload);
        case actionTypes.UPDATE_IN_MESSAGE_LIST: return updateInLists(state, action.payload);
        case actionTypes.REMOVE_FROM_MESSAGE_LIST: return removeFromLists(state, action.payload);
        case actionTypes.FETCH_MESSAGE_START: return fetchRecordStart(state);
        case actionTypes.FETCH_MESSAGE_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_MESSAGE_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_MESSAGE: return clearRecord(state);
        case actionTypes.ADD_MESSAGE_START: return addRecordStart(state);
        case actionTypes.ADD_MESSAGE_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_MESSAGE_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_MESSAGE_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_MESSAGE_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_MESSAGE_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_SINGLE_MESSAGE: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_MESSAGE_START: return updateRecordStart(state);
        case actionTypes.UPDATE_MESSAGE_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_MESSAGE_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_MESSAGE_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_MESSAGE_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_MESSAGE_CANCEL: return cancelUpdateRecord(state);
        default:
            return state;
    }
};

export default reducer;